import { AppActionAsync, AppActionSync, EmitEvents } from "remo-types/src/ipc";

// Electron窗口通信
export const sendToOverlay = <T extends keyof EmitEvents>(
    eventName: T,
    args?: EmitEvents[T],
): void => {
    (window as any).electron?.ipcRenderer.send("resend-to-overlay-window", {
        eventName,
        data: args,
    });
};

export const send = <T extends keyof AppActionAsync>(
    eventName: T,
    args?: AppActionAsync[T],
): void => {
    (window as any).electron?.ipcRenderer.send(eventName, args);
};

export const invoke = <T extends keyof AppActionSync, U extends Parameters<AppActionSync[T]>[0]>(
    action: T,
    args?: U,
): ReturnType<AppActionSync[T]> => {
    return (window as any).electron?.ipcRenderer.invoke(action, args);
};

export const listenEvent = <T extends keyof EmitEvents>(
    eventName: T,
    callbacks: (args: EmitEvents[T]) => any,
): void => {
    (window as any).electron?.ipcRenderer.on(eventName, (_e: any, data: EmitEvents[T]) => {
        callbacks(data);
    });
};

export const removeEvent = <T extends keyof EmitEvents>(eventName: T): void => {
    (window as any).electron?.ipcRenderer.removeAllListeners(eventName);
};
